import { render, staticRenderFns } from "./ProductDetail_Coupon.vue?vue&type=template&id=f3a66eb8&scoped=true"
import script from "./ProductDetail_Coupon.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a66eb8",
  null
  
)

export default component.exports